import { invokeApi } from "../../bl_libs/invokeApi";

export const selfImageMemberListingApi = async (page, limit, data) => {
  const requestObj = {
    path: `api/questionnaire/list_member_replies_against_module?page=0&limit=50`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const self_image_responded_users = async (page, limit, search_text) => {
  const requestObj = {
    path: `api/member/history/list?page=${page}&limit=${limit}&search_text=${search_text}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const goalIncompleteMemberListingApi = async (type) => {
  const requestObj = {
    path: `api/goal_statement_question/user_list_goal_statement_for_consultant?type=incomplete`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const selfSaveAndCloseListApi = async (id, type) => {
  const requestObj = {
    path: `api/questionnaire/self_image/responded/${id}?type=${type}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const goalSaveAndCloseAddApi = async (data) => {
  const requestObj = {
    path: `api/goal_statement_question/goal_statement_save_and_close`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const selfImageMarkIncompleteApi = async (id) => {
  const requestObj = {
    path: `api/questionnaire/self_image/incomplete/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const selfImageDetailApi = async (data) => {
  const requestObj = {
    path: `api/questionnaire/list_question_reply_against/lesson`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const selfImageRepliesShowApi = async (data) => {
  const requestObj = {
    path: `api/questionnaire/set/show_replies`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const AddCommentOnSelfImageQuestion = async (data) => {
  const requestObj = {
    path: `api/questionnaire/add_comment_on_member_replies`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const editCommentOnSelfImageQuestion = async (data) => {
  const requestObj = {
    path: `api/questionnaire/edit_reply_by/admin`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const DeleteSelfImageQuestionCommentApi = async (data) => {
  const requestObj = {
    path: `api/questionnaire/delete_reply_by/admin`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
// export const getDetailQuestion = async (id) => {
//   const requestObj = {
//     path: `api/goal_statement_question/${id}`,
//     method: "GET",
//     headers: {
//       "x-sh-auth": localStorage.getItem("token"),
//     },
//   };
//   return invokeApi(requestObj);
// };

export const AddCommentOnQuestion = async (data) => {
  const requestObj = {
    path: `api/goal_statement_question/add_comment_on_goal_statement_question`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
// export const EditQuestion = async (data, id) => {
//   console.log(id, "params.id");
//   const requestObj = {
//     path: `api/goal_statement_question/consultant/${id}`,
//     method: "PUT",
//     headers: {
//       "x-sh-auth": localStorage.getItem("token"),
//     },
//     postData: data,
//   };
//   return invokeApi(requestObj);
// };
// // export const getGoalStatementQuestion = async (id) => {
// //   console.log(id, "params.id");
// //   const requestObj = {
// //     path: `api/member/get_goal_statement_by_member_id/${id}`,
// //     method: "GET",
// //     headers: {
// //       "x-sh-auth": localStorage.getItem("token"),
// //     },
// //     // postData: data,
// //   };
// //   return invokeApi(requestObj);
// // };
export const DeleteQuestionCommentApi = async (id) => {
  const requestObj = {
    path: `api/goal_statement_question/comment/${id}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    // postData: data,
  };
  return invokeApi(requestObj);
};
export const questionReplyHistory = async (data) => {
  const requestObj = {
    path: `api/member/get_answer_stat`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const replyAgainstSelfImageApi = async (data) => {
  const requestObj = {
    path: `api/questionnaire/reply_on_member/answers`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const DeleteSelfImageReplyApi = async (data) => {
  const requestObj = {
    path: `api/questionnaire/delete_reply_on_member/answers`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const get_member_history_api = async (path) => {
  const requestObj = {
    path: path,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const get_history_detail_api = async (user_id) => {
  const requestObj = {
    path: `api/member/history/detail/${user_id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
